module.exports = __webpack_public_path__ + "./images/8d379709deb9c57bb2ff187f5560f65e.webp";